import { render, staticRenderFns } from "./DailyActivityLegend.vue?vue&type=template&id=74968e8c&"
import script from "./DailyActivityLegend.vue?vue&type=script&lang=js&"
export * from "./DailyActivityLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports